import { IndexedDBCryptoStore } from 'matrix-js-sdk/src/crypto/store/indexeddb-crypto-store';
import { LocalStorageCryptoStore } from 'matrix-js-sdk/src/crypto/store/localStorage-crypto-store';
import { MemoryCryptoStore } from 'matrix-js-sdk/src/crypto/store/memory-crypto-store';
import { createClient, MatrixClient } from 'matrix-js-sdk/src/matrix';
import { IndexedDBStore } from 'matrix-js-sdk/src/store/indexeddb';
import { MemoryStore } from 'matrix-js-sdk/src/store/memory';

const indexedDB = window.indexedDB;
const localStorage = window.localStorage;

export const createIndexedDBStore = () => {
  if (indexedDB && localStorage) {
    return new IndexedDBStore({
      indexedDB: global.indexedDB,
      localStorage: global.localStorage,
      dbName: 'web-sync-store',
    });
  } else if (localStorage) {
    return new MemoryStore({ localStorage });
  }
};

export const startupStores = async (matrixClient: MatrixClient | null) => {
  if (!matrixClient) return;

  for (const dbType of ['indexeddb', 'memory']) {
    try {
      const promise = matrixClient.store.startup();
      await promise;
      break;
    } catch (err) {
      if (dbType !== 'indexeddb') throw err;

      matrixClient.store = new MemoryStore({ localStorage });
    }
  }
};

export const createCryptoStore = () => {
  if (indexedDB) {
    return new IndexedDBCryptoStore(global.indexedDB, 'crypto-store');
  } else if (localStorage) {
    return new LocalStorageCryptoStore(localStorage);
  } else {
    return new MemoryCryptoStore();
  }
};

export const checkMatrixCreds = async (accessToken: string, userId: string, baseUrl: string) => {
  const client = createClient({ baseUrl });
  client.setAccessToken(accessToken);

  const { user_id } = await client.whoami();

  // NOTE: reject promise if user id in cookies does not match user id from whoami response
  if (userId !== user_id) return Promise.reject();
};

export enum MatrixLoggingInStatusEnum {
  INITIAL = 'initial',
  RUNNING = 'running',
  FINISHED = 'finished',
}
